<template>
	<div class="dsxxindex">
		<div class="djxxhome_wrap">
			<!-- 筛选学段分类 -->
			<div class="select_school">
				<div class="select_school_left">
					资源类型:
				</div>
				<div class="select_school_right">
				
					<div v-for="item in DyClass" :key="item.id" @click="changeFirst(item.id)"
						class="select_school_right_item" :class="getData.type == item.id ? 'select_title1' : ''">{{
							item.title }}
					</div>
				</div>

			</div>
			<!-- 德育资源二级分类 -->
			<div class="select_profession">
				<div class="select_profession_left">
					所属省份:
				</div>
				<div class="select_profession_right" id="btn">
					<div @click="changeSecond('')" :class="getData.province == '' ? 'select_title1' : ''"
						class="select_profession_right_item">全部</div>
					<div @click="changeSecond(item.title)" v-for="item in provinceList"
						:class="getData.province == item.title ? 'select_title1' : ''" class="select_profession_right_item">
						{{item.title }}</div>

				</div>
				<div class="btn" @click="dianjiBtn">
					<span class="first_span">{{ btn }}</span>
					<span v-if="btn == '展开'">
						<img src="../../assets/hejin/dowm_icon.png" alt="">
					</span>
					<span v-if="btn == '收起'">
						<img src="../../assets/hejin/up_icon.png" alt="">
					</span>
				</div>
			</div>
			<!-- 视频列表 -->
			<div class="dataList" v-if="dataList.length>0">
				<!-- 遍历列表循环 -->
				<div class="dataList_item" v-for="item in dataList" 
					@click="goDetail(item)">
					<div class="dataList_item_top_img">
						<img :src="item.sz_img" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 下方课程信息 -->
					</div>
				</div>
			</div>
			<div class="dataList" v-else>
			   <img style="width: 392px;height: 325px;margin: 50px auto;" src="@/assets/hejin/qj_nodata.png" alt="">
				
				
			</div>
			<!-- 下方分页器 -->
			<Page style="margin: 40px auto;" :total="total" :per_page="getData.page" :pageSize="[12]" @handleCurrentChange="handleCurrentChange">
			</Page>
		</div>

	</div>
</template>
<script>
import { shouye } from '@/axios';
import Page from '@/components/page.vue'
export default {
	name:'hsyzt',
	data() {
		return {
			// 总数据条数
			total: 0,
			// 当前页码
			per_page: 1,
			// 筛选学段分类
			selectFirst: this.$route.query.one_id,
			// 筛选资源分类
			selectSecond: '',
			selectdySecond: this.$route.query.two_id,
			// 党史学习分类
			DsxxClass: [],
			// 党史学习列表
			dataList: [
			
			],
			// 德育资源一级分类
			DyClass: [
				{ id: 1, title: '云展厅' },
				{ id: 2, title: 'VR全景' }
			],
		    getData:{
				type:'1',
				province:'',
				page:1
			},
			btn: '展开',
			provinceList:[]

		}
	},
	components: { Page },
	methods: {
		getProvinceList(){
           let that=this
		   shouye.provinceList().then(res=>{
			
			if (res.code==200) {
				this.provinceList=res.data
				this.getData.type=1
				this.getDataList()

			}
		   })
		},
		getDataList(){
			let that=this
			shouye.hsyztList(that.getData).then(res=>{
		
			if (res.code==200) {
				this.dataList=res.data.list
				this.total=Number(res.data.count)

			}
		   })
		},
		//   分页器页码发生变化
		handleCurrentChange(val) {
			
			this.getData.page=val
			this.getDataList()

		},
		// 改变一级分类
		changeFirst(data) {
			let that = this
			that.getData.type = data
			that.getData.page=1
			that.getDataList()
		},
		// 改变二级分类
		changeSecond(data) {
			let that = this
			that.getData.province = data
			that.getData.page=1
			that.getDataList()
		},
		// 跳转至详情
		goDetail(item) {
			let that = this
			if (this.getData.type==1) {
				this.$router.push({
				path: "/hsyztDetail",
				query: {
					id: item.id,
					type:that.getData.type
	
				}
			})
			}else{
				window.open(item.ar_url)
			}
		},

		// 点击展开按钮
		dianjiBtn() {
			var that = this;
			if (that.btn == "展开") {
				that.btn = "收起"
				let ClickBtn = document.getElementById('btn')

				ClickBtn.style.height = 'auto'


			} else {
				that.btn = "展开"
				let ClickBtn = document.getElementById('btn')
				ClickBtn.style.height = '60px'
			}
		},
		
	},
	mounted() {
         this.getProvinceList()
		 let ClickBtn = document.getElementById('btn')
	  	ClickBtn.style.height = '60px'
		  this.$emit("highLight", this.$route.query.index, "", "", "");

	},
	created() {
		
	}
}
</script>
<style lang="scss">
@import '@/common/index.scss';

.select_title1 {
	background-color: #C21B14;
	color: #fff;
	font-weight: 800;
}

.dsxxindex {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.djxxhome_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
		position: relative;

		// 筛选资源分类
		.select_school {
			margin-top: 10px;
			box-sizing: border-box;
			height: 60px;
			line-height: 60px;
			border-bottom: 1px solid #ECEEF4;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.select_school_left {
				font-family: PingFangSC-Semibold;
				font-size: 14px;
				font-weight: 800;
				letter-spacing: 0em;
				color: #000000;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
			}

			.select_school_right {
				font-family: PingFangSC-Regular;
				font-size: 14px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				display: flex;
				justify-content: flex-start;

				.select_school_right_item {
					box-sizing: border-box;
					height: 24px;
					// width: 60px;
					padding: 0 12px;
					margin: 20px;
					line-height: 24px;
					text-align: center;
					border-radius: 12px;
				}


			}
		}

		.select_school:nth-child(2) {
			margin-top: 0px;
		}

		/* 视频列表 */
		.dataList {
			width: 100%;
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
            gap: 20px;
			.dataList_item {
				width: 285px;
				height: 200px;
				border-radius: 4px;
				overflow: hidden;
				border: 1px solid #ECEEF4;
				.dataList_item_top_img {
					height: 160px;
					width: 285px;
				
					img {
						width: 100%;
						height: 100%;
					}
				}

				.dataList_item_bottom {
					width: 100%;
					height: 40px;
					border-radius: 0 0 4px 4px;
					padding: 10px;
                    
					.dataList_item_bottom_top_title {
						width: 100%;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 20px;
						color: #000000;
						
					}

					.dataList_item_bottom_top_title:hover {
						color: #C9010A;
					}

				}


			}

			.dataList_item:nth-child(5n) {
				margin-right: 0;

			}
		}



	}
}

// 筛选专业及学科类型
.select_profession {
	box-sizing: border-box;
	border-bottom: 1px solid #ECEEF4;
	display: flex;
	justify-content: flex-start;
	.select_profession_left {
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		font-weight: 800;
		letter-spacing: 0em;
		color: #000000;
		width: 60px;
		height: 60px;
		line-height: 60px;
	}

	.select_profession_right {
		min-height: 60px;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		font-weight: normal;
		letter-spacing: 0em;
		color: #666666;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 1100px;
		flex-wrap: wrap;
		overflow: hidden;


		.select_profession_right_item {
			box-sizing: border-box;
			height: 24px;
			padding: 0 12px;
			margin: 20px;
			line-height: 24px;
			text-align: center;
			border-radius: 12px;
			box-sizing: border-box;
		}

	}
}

.btn {
	font-family: PingFangSC-Regular;
	font-size: 14px;
	font-weight: normal;
	letter-spacing: 0em;
	color: #CB272B;
    height: 60px;
	margin-top: 20px;
	cursor: pointer;
	.first_span {
		margin-right: 5px;
	}

	span {
		position: relative;

		img {
			position: absolute;
			top: 7px;
		}
	}
}
</style>
